/* eslint-disable */

import axios from 'axios';
import { getIdToken as getFirebaseIdToken } from '@/pages/MyAccount/components/firebaseIdToken';

//axios.defaults.baseURL = 'https://y0gky23tog.execute-api.us-east-1.amazonaws.com/dev';
axios.defaults.baseURL = process.env.VUE_APP_TEAMIO_API_URL

// H23: /create-workflow and /update-workflow now verify a Firebase ID token server-side.
// Callers that omit the header get 401; a null token degrades to a headerless request.
async function workflowAuthConfig(rootState) {
  const idToken = await getFirebaseIdToken(rootState && rootState.getAuth ? rootState.getAuth() : null);
  const headers = {};
  if (idToken) headers.Authorization = `Bearer ${idToken}`;
  return { crossdomain: true, headers };
}

export default {

    namespaced: true,
    state: {
        workflows: [],
    },
    mutations: {

    },
    actions: {
     
        async createWorkflow({commit, dispatch, rootState}, payload) {
            const skipAlertLoading = payload.skipAlertLoading;
            if (skipAlertLoading) delete payload.skipAlertLoading;
            try {
                if (!skipAlertLoading) dispatch('alert/setLoading', true, {root: true});
                let response = await axios.post('/create-workflow', payload, await workflowAuthConfig(rootState));

                if (!skipAlertLoading) {
                    dispatch('alert/setLoaded', true, {root: true});
                    dispatch('alert/setMessage', 'Workflow page created successfully!', {root: true});
                    dispatch('alert/setDismissSuccessCountDown', 3, {root: true});
                }
                return response;
            } catch(err) {
                console.log('Error creating workflow:', err);
                if (!skipAlertLoading) {
                    dispatch('alert/setErrored', true, {root: true});
                    dispatch('alert/setMessage', err, {root: true});
                }
                throw err;
            }
        },

        async getWorkflow({commit, dispatch}, payload) {
            try {
                dispatch('alert/setLoading', true, {root: true});
                let response = await axios.post('/get-workflow', payload, { crossdomain: true });
                //console.log('Response:' + JSON.stringify(response));
                
                // Simulating async call to external service
                //await new Promise(resolve => setTimeout(resolve, 2000));
                //throw new Error("Something bad happened");
                
                dispatch('alert/setLoaded', true, {root: true});
                //dispatch('alert/setMessage', 'Workflow page created successfully!', {root: true});
                dispatch('alert/setDismissSuccessCountDown', 3, {root: true});
                return response;
            } catch(err) {
                console.log('Error getting workflow:', err);
                dispatch('alert/setErrored', true, {root: true});
                dispatch('alert/setMessage', err, {root: true});
            }
        },

        async updateWorkflow({commit, dispatch, rootState}, payload) {
            const skipAlertLoading = payload.skipAlertLoading;
            if (skipAlertLoading) delete payload.skipAlertLoading;
            try {
                if (!skipAlertLoading) dispatch('alert/setLoading', true, {root: true});
                let response = await axios.post('/update-workflow', payload, await workflowAuthConfig(rootState));

                if (!skipAlertLoading) {
                    dispatch('alert/setLoaded', true, {root: true});
                    dispatch('alert/setMessage', 'Workflow updated successfully!', {root: true});
                    dispatch('alert/setDismissSuccessCountDown', 3, {root: true});
                }
                return response;
            } catch(err) {
                let errMsg = `Error updating a Workflow: ${err}`;
                console.log(errMsg);
                if (!skipAlertLoading) {
                    dispatch('alert/setErrored', true, {root: true});
                    dispatch('alert/setMessage', errMsg, {root: true});
                }
                throw err;
            }
        },

        // `skipAlertLoading` (as in updateWorkflow): the caller draws its own busy state and result, so the
        // app-wide alert bar stays out of it. The redesigned Workflows pages pass it; classic does not.
        async enableWorkflow({commit, dispatch}, payload) {
            const skipAlertLoading = payload.skipAlertLoading;
            if (skipAlertLoading) {
                payload = Object.assign({}, payload);
                delete payload.skipAlertLoading;
            }
            try {
                if (!skipAlertLoading) dispatch('alert/setLoading', true, {root: true});
                let response = await axios.post('/enable-workflow', payload, { crossdomain: true });
                //console.log('Response:' + JSON.stringify(response));

                // Simulating async call to external service
                //await new Promise(resolve => setTimeout(resolve, 2000));
                //throw new Error("Something bad happened");

                if (!skipAlertLoading) {
                    dispatch('alert/setLoaded', true, {root: true});
                    dispatch('alert/setMessage', 'Workflow enabled successfully!', {root: true});
                    dispatch('alert/setDismissSuccessCountDown', 3, {root: true});
                }
            } catch(err) {
                console.log(`Got error in store`);
                if (!skipAlertLoading) {
                    dispatch('alert/setErrored', true, {root: true});
                    dispatch('alert/setMessage', err, {root: true});
                }
                throw(err);
            }
        },

        async disableWorkflow({commit, dispatch}, payload) {
            const skipAlertLoading = payload.skipAlertLoading;
            if (skipAlertLoading) {
                payload = Object.assign({}, payload);
                delete payload.skipAlertLoading;
            }
            try {
                if (!skipAlertLoading) dispatch('alert/setLoading', true, {root: true});
                let response = await axios.post('/disable-workflow', payload, { crossdomain: true });
                //console.log('Response:' + JSON.stringify(response));

                // Simulating async call to external service
                //await new Promise(resolve => setTimeout(resolve, 2000));
                //throw new Error("Something bad happened");

                if (!skipAlertLoading) {
                    dispatch('alert/setLoaded', true, {root: true});
                    dispatch('alert/setMessage', 'Workflow disabled successfully!', {root: true});
                    dispatch('alert/setDismissSuccessCountDown', 3, {root: true});
                }
            } catch(err) {
                if (!skipAlertLoading) {
                    dispatch('alert/setErrored', true, {root: true});
                    dispatch('alert/setMessage', err, {root: true});
                }
                throw(err);
            }
        },

        async deleteWorkflow({commit, dispatch}, payload) {
            try {
                //dispatch('alert/setLoading', true, {root: true});
                let response = await axios.post('/remove-workflow', payload, { crossdomain: true });
                //console.log('Response:' + JSON.stringify(response));
                
                // Simulating async call to external service
                //await new Promise(resolve => setTimeout(resolve, 2000));
                //throw new Error("Something bad happened");                
                
                //dispatch('alert/setLoaded', true, {root: true});
                //dispatch('alert/setMessage', 'Workflow deleted successfully!', {root: true});
                //dispatch('alert/setDismissSuccessCountDown', 3, {root: true});
                return response;
            } catch(err) {
                console.log('Error deleting a Workflow', err);
                //dispatch('alert/setErrored', true, {root: true});
                //dispatch('alert/setMessage', err, {root: true});
                throw err;
            }
        },

        async getAllWorkflows({commit, dispatch}, payload) {
            try {
                dispatch('alert/setLoading', true, {root: true});
                let response = await axios.post('/get-all-workflows', payload, { crossdomain: true });
                //console.log('Response:' + JSON.stringify(response));                
                dispatch('alert/setLoaded', true, {root: true});
                return response.data || [];
            } catch(err) {
                console.log('Error getting all workflows:', err);
                dispatch('alert/setErrored', true, {root: true});
                dispatch('alert/setMessage', err, {root: true});
                return []; // Return empty array instead of undefined
            }
        },

        async getWorkflowOutput({commit, dispatch}, payload) {
            try {
                dispatch('alert/setLoading', true, {root: true});
                let response = await axios.post(`/workflow-output/${payload.WorkflowID}`, payload, { crossdomain: true });
                //console.log('Response:' + JSON.stringify(response));                
                dispatch('alert/setLoaded', true, {root: true});
                return response.data;
            } catch(err) {
                console.log('Error getting workflow output:', err);
                dispatch('alert/setErrored', true, {root: true});
                dispatch('alert/setMessage', err, {root: true});
            }
        },
    }
}